<template>
  <div>
    <LoadingSpinner :loading="isLoading" />
    <b-form @submit.prevent="submit" v-if="!isLoading">
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.eventCaption"
            label-for="caption"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.eventCaption"
              :rules="$v.caption.$params"
            />
            <b-form-input
              id="caption"
              type="text"
              autocomplete="off"
              v-model="$v.caption.$model"
              :state="$v.caption.$dirty ? !$v.caption.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="caption-feedback"
              >{{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.caption)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" class="mb-3">
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.explanation"
            :rules="$v.description.$params"
          />
          <b-form-invalid-feedback
            id="name-feedback"
            :style="{
              display: $v.description.$error ? 'block' : 'none',
            }"
          >
            {{
              $lang.azmoonLang.error_required
                | replace($lang.azmoonLang.explanation)
            }}</b-form-invalid-feedback
          >
          <Editor dir="rtl" v-model="description">
            <br />
          </Editor>
        </b-col>
        <b-col v-if="showStateDefine" cols="12" md="">
          <b-form-group
            :label="$lang.azmoonLang.state_define"
            label-for="state_define"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.state_define"
              :rules="$v.state_define_selected.$params"
            />
            <selectFind
              :options="state_define_options"
              v-model="$v.state_define_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.state_define_selected.$dirty
                  ? !$v.state_define_selected.$error
                  : null
              "
              :loading="state_define_Loading"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.state_define_selected.$error ? 'block' : 'none',
              }"
              id="state_define_selected_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.state_define)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" :md="showActivityTiming ? 6 : 12">
          <b-form-group
            :label="$lang.azmoonLang.activity_reference"
            label-for="actions_activity"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.activity_reference"
              :rules="$v.actions_selected.$params"
              :showInfo="true"
              :titleText="$lang.azmoonLang.activity_reference"
            />
            <selectFind
              :options="actions_activity"
              v-model="$v.actions_selected.$model"
              label="caption"
              id="id"
              :loading="actions_loading"
              :removeItem="removeItemActivity"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.actions_selected.$error ? 'block' : 'none',
              }"
              id="actions_activity_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.activity_reference)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" class="mb-3" v-if="showActivityTiming">
          <b-card>
            <div slot="header">
              <strong v-text="'زمانبدی شروع فعالیت'" />
            </div>
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.azmoonLang.time_checkpoint"
                  label-for="time_checkpoint"
                  :label-cols="$config.azmoon.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.azmoonLang.time_checkpoint"
                    :rules="$v.time_checkpoint_selected.$params"
                    :showInfo="true"
                    :titleText="$lang.azmoonLang.time_checkpoint_tooltip"
                  />
                  <selectFind
                    :options="time_checkpoint_options"
                    v-model="$v.time_checkpoint_selected.$model"
                    label="text"
                    id="value"
                    :isValid="
                      $v.time_checkpoint_selected.$dirty
                        ? !$v.time_checkpoint_selected.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.time_checkpoint_selected.$error
                        ? 'block'
                        : 'none',
                    }"
                    id="time_checkpoint_selected_feedback"
                  >
                    {{
                      $lang.azmoonLang.error_required
                        | replace($lang.azmoonLang.time_checkpoint)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.azmoonLang.diff_time_checkpoint"
                  label-for="diff_time_checkpoint"
                  :label-cols="$config.azmoon.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.azmoonLang.diff_time_checkpoint"
                    :rules="$v.diff_time_checkpoint.$params"
                    :showInfo="true"
                    :titleText="$lang.azmoonLang.diff_time_checkpoint_tooltip"
                  />

                  <b-form-input
                    id="diff_time_checkpoint"
                    type="number"
                    min="0"
                    max="999"
                    autocomplete="off"
                    v-model="$v.diff_time_checkpoint.$model"
                    :state="
                      $v.diff_time_checkpoint.$dirty
                        ? !$v.diff_time_checkpoint.$error
                        : null
                    "
                  />
                  <b-form-text id="input-live-help">
                    {{ $lang.azmoonLang.minute }}
                  </b-form-text>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.diff_time_checkpoint.required"
                  >
                    {{
                      $lang.azmoonLang.error_required
                        | replace($lang.azmoonLang.diff_time_checkpoint)
                    }}
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="
                      $v.diff_time_checkpoint.required &&
                      (!$v.diff_time_checkpoint.minLengh ||
                        !$v.diff_time_checkpoint.maxLengh)
                    "
                  >
                    {{
                      $lang.azmoonLang.error_Value
                        | replace(
                          $lang.azmoonLang.diff_time_checkpoint,
                          "0",
                          "999"
                        )
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.azmoonLang.timeing"
                  label-for="timeing"
                  :label-cols="$config.azmoon.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.azmoonLang.timeing"
                    :rules="$v.timeing_selected.$params"
                  />
                  <selectFind
                    :options="timeing_options"
                    v-model="$v.timeing_selected.$model"
                    label="text"
                    id="value"
                    :isValid="
                      $v.timeing_selected.$dirty
                        ? !$v.timeing_selected.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.timeing_selected.$error ? 'block' : 'none',
                    }"
                    id="timeing_selected_feedback"
                  >
                    {{
                      $lang.azmoonLang.error_required
                        | replace($lang.azmoonLang.timeing)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.azmoonLang.duration_activity"
                  label-for="duration_activity"
                  :label-cols="$config.azmoon.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.azmoonLang.duration_activity"
                    :rules="$v.duration_activity.$params"
                    :showInfo="true"
                    :titleText="$lang.azmoonLang.duration_activity_tooltip"
                  />

                  <b-form-input
                    id="duration_activity"
                    type="number"
                    min="0"
                    max="999"
                    autocomplete="off"
                    v-model="$v.duration_activity.$model"
                    :state="
                      $v.duration_activity.$dirty
                        ? !$v.duration_activity.$error
                        : null
                    "
                  />
                  <b-form-text id="input-live-help">{{
                    $lang.azmoonLang.minute
                  }}</b-form-text>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.duration_activity.required"
                  >
                    {{
                      $lang.azmoonLang.error_required
                        | replace($lang.azmoonLang.duration_activity)
                    }}
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="
                      $v.duration_activity.required &&
                      (!$v.duration_activity.minLengh ||
                        !$v.duration_activity.maxLengh)
                    "
                  >
                    {{
                      $lang.azmoonLang.error_Value
                        | replace(
                          $lang.azmoonLang.duration_activity,
                          "0",
                          "999"
                        )
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="12"
                v-if="
                  diff_time_checkpoint &&
                  timeing_selected &&
                  time_checkpoint_selected
                "
              >
                <b-alert show variant="primary" dismissible>
                  <h6 class="text-center">
                    {{
                      $lang.azmoonLang.tooltip_activity_time
                        .replace("{0}", diff_time_checkpoint)
                        .replace("{1}", timeing_selected.text)
                        .replace("{2}", time_checkpoint_selected.text)
                    }}
                    <span v-if="duration_activity">{{
                      $lang.azmoonLang.tooltip_duration_activity.replace(
                        "{3}",
                        duration_activity
                      )
                    }}</span>
                  </h6>
                </b-alert>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="12" md="" class="white-space mt-2">
          <b-form-checkbox
            id="start_at_time"
            v-model="start_at_time"
            name="start_at_time"
            :disabled="+start_at_period === 1"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.start_at_time }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.azmoonLang.start_at_time_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>
        <b-col
          cols="12"
          md=""
          class="white-space mt-2"
          v-if="duration_activity && +start_at_time !== 1"
        >
          <b-form-checkbox
            id="start_at_period"
            v-model="start_at_period"
            name="start_at_period"
            :disabled="!duration_activity || +start_at_time === 1"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.start_at_period }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.azmoonLang.start_at_period_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="" class="white-space mt-2 mb-3">
          <b-form-checkbox
            id="has_prerequisite"
            v-model="has_prerequisite"
            name="has_prerequisite"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.prerequisites }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.azmoonLang.prerequisites_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>
        <b-col v-if="mode === 'edit'" cols="12" md="12" class="mt-2 px-0">
          <UploadFile
            v-if="itemId"
            title="فایل‌ها"
            :keyServies="keyService"
            :keyValue="itemId"
            :file_types="file_types"
            :parentAttachmentTypeId="attachmentTypeId"
            attachmentRoute="attachment"
            attachment_type_name="attachment_type_activity"
            :showForm="false"
            :allowCollapse="false"
            :isCollapseFiles="true"
            :maxUploadFile="10485760"
            :allowFileSize="10240"
            :acceptFormats="acceptFormats"
          />
        </b-col>
        <b-col v-if="mode === 'add'" cols="12" md="12" class="mt-2 border-top">
          <AttachFile
            ref="attachFile"
            class="mb-2 bg-white mb-3 rounded"
            @responseCode="setResponseCode"
            :acceptFormats="acceptFormats"
            :parentAttachmentTypeId="attachmentTypeId"
          />
        </b-col>
        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="reset"
              class="mr-2"
              variant="outline-danger"
              @click="cancel"
            >
              <mdicon name="close" size="20" />
              {{ $lang.azmoonLang.cancelButton }}
            </b-button>
            <b-button type="submit" v-if="permissionBtn" variant="success">
              <mdicon name="check" size="20" />
              {{ $lang.azmoonLang.submitButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Editor from "@/components/ckeditor/editor";
import UploadFile from "@/components/base/uploadFile.vue";
import AttachFile from "@/components/base/attachFile";
import { required, numeric, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { renderEumOptions, generateApiUrl } from "@/shared/utils";
import { createPureDom } from "@/shared/utils";
export default {
  name: "activity-form",
  components: {
    UploadFile,
    Editor,
    AttachFile,
    LoadingSpinner,
  },
  validations: {
    caption: {
      required,
    },
    state_define_selected: {},
    diff_time_checkpoint: {
      required: requiredIf((vm) => vm.showActivityTiming),
      numeric,
    },
    time_checkpoint_selected: {
      required: requiredIf((vm) => vm.showActivityTiming),
    },
    duration_activity: {
      required: requiredIf((vm) => vm.showActivityTiming),
    },
    timeing_selected: {
      required: requiredIf((vm) => vm.showActivityTiming),
    },
    description: { required },
    actions_selected: {},
  },
  props: {
    permissionBtn: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: [String, Number],
      default: null,
    },
    parentId: {
      type: [String, Number],
      default: null,
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    keyAction: {
      type: String,
      default: "",
    },
    keyService: {
      type: String,
      default: "",
    },
    keyIndex: {
      type: String,
      default: null,
    },
    term_id: {
      type: [String, Number],
      default: null,
    },
    term_code: {
      type: [String, Number],
      default: null,
    },
    mode: {
      type: String,
      default: "add",
    },
    showStateDefine: {
      type: Boolean,
      default: true,
    },
    showActivityTiming: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      file_types: ["image", "office", "media", "other"],
      state_define_options: [],
      state_define_selected: {},
      state_define_Loading: false,
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      caption: null,
      diff_time_checkpoint: null,
      duration_activity: null,
      time_checkpoint_selected: null,
      has_prerequisite: 0,
      start_at_time: 0,
      start_at_period: 0,
      description: null,
      timeing_selected: null,
      actions_activity: [],
      actions_selected: null,
      actions_loading: false,
      fileUpload: [],
      responseCode: [],
      isLoading: false,
      item: null,
    };
  },
  computed: {
    role_options() {
      return renderEumOptions("executive_role");
    },
    time_checkpoint_options() {
      return renderEumOptions("activity_time_checkpoint");
    },
    timeing_options() {
      return [
        {
          text: this.$lang.azmoonLang.timeing_options.before,
          value: 0,
        },
        {
          text: this.$lang.azmoonLang.timeing_options.after,
          value: 1,
        },
      ];
    },
    attachmentTypeId() {
      const attachmentTypeActivityOptions = renderEumOptions(
        "attachment_type_activity",
        true
      );
      return pathOr(null, ["0", "id"], attachmentTypeActivityOptions);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    generateApiUrl,
    createPureDom,
    async getStateDefine() {
      if (!this.showStateDefine) return;
      this.state_define_selected = null;
      try {
        this.state_define_Loading = true;
        const url = generateApiUrl(["azmoon", "term_parvandeh_combo_define"]);
        const params = {
          term_code: this.term_code,
        };
        const response = await this.$httpService.get(url, params);
        const data = pathOr([], ["data", "data"], response);
        this.state_define_options = data.map((x) => {
          return {
            text: x.state_caption,
            value: x.code,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.state_define_Loading = false;
      }
    },
    removeItemActivity(item) {},
    async getAction() {
      try {
        this.actions_loading = true;
        const url = generateApiUrl(["azmoon", "action"], [], {
          resource: this.keyAction,
        });
        const response = await this.$httpService.get(url);
        this.actions_activity = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.actions_loading = false;
      }
    },
    cancel() {
      this.$emit("cancel", false);
      this.$emit("modal-close", false);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      const diffTimeCheckpoint =
        pathOr(null, ["value"], this.timeing_selected) === 0
          ? -1 * parseInt(this.diff_time_checkpoint)
          : parseInt(this.diff_time_checkpoint);

      const payload = {
        time_checkpoint: pathOr(1, ["value"], this.time_checkpoint_selected),
        diff_time_checkpoint: this.showActivityTiming ? diffTimeCheckpoint : 0,
        duration: +this.duration_activity,

        term_id: this.term_id,
        term_state_code: pathOr(null, ["value"], this.state_define_selected),
        has_prerequisite: this.has_prerequisite
          ? parseInt(this.has_prerequisite)
          : 0,
        start_at_time: +this.start_at_time,
        start_at_period: +this.start_at_period,
        caption: this.caption,
        description: this.description,
        custom_action_id: pathOr(null, ["id"], this.actions_selected),
      };
      if (!this.showStateDefine) {
        delete payload.term_state_code;
      }

      this.$emit("submit", payload);
    },
    setResponseCode(value) {
      this.$emit("setResponseCode", value);
    },
    async getData() {
      if (!this.itemId) return;
      try {
        const url = generateApiUrl(
          ["azmoon", "activity_id"],
          [this.keyIndex, this.parentId, this.itemId]
        );

        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.caption = pathOr(null, ["caption"], data);
        this.description = createPureDom(pathOr(null, ["description"], data));

        this.has_prerequisite = pathOr(null, ["has_prerequisite"], data);
        this.start_at_time = pathOr(null, ["start_at_time"], data);
        this.start_at_period = pathOr(null, ["start_at_period"], data);
        const diffTimeCheckpoint = pathOr(null, ["diff_time_checkpoint"], data);
        this.diff_time_checkpoint = Math.abs(diffTimeCheckpoint);
        const duration = pathOr(null, ["duration"], data);

        this.duration_activity = duration;
        if (diffTimeCheckpoint || diffTimeCheckpoint === 0) {
          const valTiming =
            Math.sign(diffTimeCheckpoint) === 1 ||
            Math.sign(diffTimeCheckpoint) === 0
              ? 1
              : 0;
          this.timeing_selected = this.timeing_options.find(
            (x) => x.value === valTiming
          );
        }
        this.time_checkpoint_selected = this.time_checkpoint_options.find(
          (x) => x.value === pathOr(null, ["time_checkpoint"], data)
        );
        if (this.showStateDefine) {
          this.state_define_selected = this.state_define_options.find(
            (x) => x.value === pathOr(null, ["term_state_code"], data)
          );
        }
        this.actions_selected = pathOr(null, ["action"], data);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        await this.getStateDefine();
        this.getAction();
        await this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.white-space {
  white-space: nowrap;
}
</style>
